import Form from '../_form';

const [ REDIRECTION_TIMEOUT, REDIRECTION_PATH ] = [ 3000, `${window.location.origin}/auth/sign-in` ];

export default class ChangePasswordForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        const form = document.querySelector(query);
        if (!form) return;

        const heading = document.querySelector('#change-password-heading');
        if (!heading) throw new Error('Change password heading element not found!');

        const staticImage = document.querySelector('#reset-password-image-static');
        if (!staticImage) throw new Error('Change password image element not found!');

        const successImage = document.querySelector('#reset-password-image-success');
        if (!successImage) throw new Error('Change password image element not found!');

        const pending = document.querySelector('#change-password-pending');
        if (!pending) throw new Error('Change password pending element not found!');

        const success = document.querySelector('#change-password-success');
        if (!success) throw new Error('Change password success element not found!');

        this.success = success;
        this.successImage = successImage;
        this.staticImage = staticImage;
        this.pending = pending;
        this.heading = heading;
    }

    handleSuccess () {
        this.form.classList.add('hidden');
        this.success.classList.remove('hidden');
        this.pending.classList.add('hidden');
        this.heading.classList.add('hidden');
        this.staticImage.classList.add('hidden');
        this.successImage.classList.remove('hidden');
    }

    handlePending () {
        this.form.classList.add('hidden');
        this.pending.classList.remove('hidden');
        this.heading.classList.add('hidden');
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const nonce = formData.get('change_password_nonce');

        const token = formData.get('token');
        const password = formData.get('password');

        this.handlePending();

        try {
            await fetch('/wp-json/auth/v1/change-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ nonce, token, password })
            })
            .then((response) => response.json())
            .then((data) => {
                if (data && !data.error) {
                    this.form.classList.remove('error');
                    this.form.classList.add('sent');

                    this.NotificationManager.sendNotification('success', 'Successfully sent!', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.handleSuccess();

                    setTimeout(() => window.location.href = REDIRECTION_PATH, REDIRECTION_TIMEOUT);
                } else {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', data.message);

                    if (this.submit) this.submit.classList.remove('preload');

                    this.form.classList.add('error');
                }
            })
            .catch(() => {
                this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

                if (this.submit) this.submit.classList.remove('preload');

                this.form.classList.add('error');
            });
        } catch (error) {
            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');

            if (this.submit) this.submit.classList.remove('preload');

            this.form.classList.add('error');
        }
    }
}
